import { Component, Input, OnInit } from '@angular/core';
import { map } from 'rxjs';

import { SettingsService } from '../service/settings.service';
import { ArmyBuilderConfig, SettingsFieldConfig, SettingsGameConfig } from '../../config';

@Component({
    standalone: false,
    selector: 'abs-settings',
    template: `
        <ng-container *ngLet="{ settings: settings$ | async } as props">
            <abs-list [items]="fields" [template]="settingsTemplate" [showDelete]="false"></abs-list>
            <ng-template #settingsTemplate let-key="item[0]" let-field="item[1]">
                <div class="itemWrap">
                    <div class="itemName">
                        <h2>{{ 'GLOBAL.SETTINGS.' + (gameId | uppercase) + '.' + (key | uppercase) + '.TITLE' | translate }}</h2>
                    </div>
                    <div class="itemDescription">
                        <p>{{ 'GLOBAL.SETTINGS.' + (gameId | uppercase) + '.' + (key | uppercase) + '.DESCRIPTION' | translate }}</p>
                    </div>
                </div>
                <div class="itemValue {{ key }}">
                    @if (field.type === 'select') {
                        <ion-select
                            *ngIf="field.type === 'select'"
                            [value]="props.settings?.[key] ?? field.defaultValue"
                            (ionChange)="settingsService.updateValue(gameId, key, $event.detail.value)"
                            slot="end"
                        >
                            <ion-select-option *ngFor="let option of field.options" [value]="option.value">
                                {{ option.label }}
                            </ion-select-option>
                        </ion-select>
                    } @else {
                        <ion-toggle
                            [slot]="'end'"
                            *ngIf="field.type === 'boolean'"
                            [checked]="!!(props.settings?.[key] ?? field.defaultValue)"
                            (ionChange)="toggleChanged(key, $event)"
                        ></ion-toggle>
                    }
                </div>
            </ng-template>
        </ng-container>
    `,
    styles: [
        `
            h2 {
                margin-top: 0;
            }

            ion-select {
                min-width: 0;
            }
        `
    ]
})
export class SettingsComponent implements OnInit {
    @Input({ required: true })
    gameId: string;

    settings$ = this.settingsService.settings$.pipe(map((settings) => settings[this.gameId] ?? {}));
    fields: [string, SettingsFieldConfig][];
    constructor(
        public settingsService: SettingsService,
        public config: ArmyBuilderConfig
    ) {
        console.log(this.config.settings);
    }

    ngOnInit() {
        this.fields = Object.entries(this.config.settings[this.gameId] || {});
    }

    toggleChanged(key: string, event: any) {
        this.settingsService.updateValue(this.gameId, key, event.detail.checked);
    }
}
